export default __webpack_public_path__ + "src/images/packages/zannier-hotels-omaanda/d4a323ffad2f3428ed090a3942a77af0-3.jpg";